import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { Expression } from "abreact/expression/Expression";
import { GuidedExpressionEditorUtils } from "abreact/expression/ui/editor/impl/utils/GuidedExpressionEditorUtils";
import { ObjectUtils } from "abweb/utils/ObjectUtils";
// import AbstractModel = GuidedExpressionEditor.AbstractModel;
// import Operand = GuidedExpressionEditor.Operand;

export class AbstractModelMediatorImpl {
  constructor(specification) {
    _defineProperty(this, "expressionDomainModel", void 0);
    _defineProperty(this, "summaryGenerator", void 0);
    _defineProperty(this, "expTemplateConfiguration", void 0);
    _defineProperty(this, "importVisitor", void 0);
    _defineProperty(this, "exportVisitor", void 0);
    this.expressionDomainModel = specification.expressionDomainModel;
    this.summaryGenerator = specification.summaryGenerator;
    this.expTemplateConfiguration = specification.expTemplateConfiguration;
    this.importVisitor = specification.importVisitor;
    this.exportVisitor = specification.exportVisitor;
    this.createDefault = this.createDefault.bind(this);
    this.import = this.import.bind(this);
    this.importInternal = this.importInternal.bind(this);
    this.export = this.export.bind(this);
  }
  async import(expExpressionDefinition, importVisitor) {
    importVisitor = Expression.Definition.ImportVisitor.composeNullable(this.importVisitor, importVisitor);
    const mutableExpExpressionDefinition = ObjectUtils.deepThaw(expExpressionDefinition);
    const generateId = GuidedExpressionEditorUtils.createGenerateIdFunction(mutableExpExpressionDefinition);
    await importVisitor?.finalizeRootExpExpressionNode?.(mutableExpExpressionDefinition.rootNode);
    await importVisitor?.finalizeExpExpressionDefinition?.(mutableExpExpressionDefinition);
    return this.importInternal(ObjectUtils.deepFreeze(mutableExpExpressionDefinition), generateId);
  }
  export(model, exportVisitor) {
    exportVisitor = Expression.Definition.ExportVisitor.composeNullable(this.exportVisitor, exportVisitor);
    return model.export(this.expressionDomainModel, {
      exportVisitor: exportVisitor,
      expTemplateConfiguration: this.expTemplateConfiguration
    });
  }
}
//# sourceMappingURL=AbstractModelMediatorImpl.js.map
